// @flow

import { useFormContext } from 'react-hook-form';

import { useCountry } from '@gandi/react-places';

import { getFlagEmoji } from 'src/modules/getFlagEmoji';

/** we want to hide the prefix if does not match the prefix
 * to avoid confusion between different possible prefix by countries */
export function shouldShowPrefix({
  phone,
  countryPhonePrefix,
}: {
  /** user input phone number */
  phone?: string,
  /** international format with + */
  countryPhonePrefix: string,
}): boolean {
  // no phone
  if (!phone) return true;

  // exact prefix match
  if (phone.startsWith(countryPhonePrefix)) return true;
  if (phone.startsWith(`00${countryPhonePrefix.slice(1)}`)) return true;

  // but not any other 00 or + kind
  if (phone.startsWith('00') || phone.startsWith('+')) return false;

  return true;
}

export function useFlagPrefix(): string | void {
  const { watch } = useFormContext();

  const country = watch('country');
  const phone = watch('phone');

  const { phonePrefix } = useCountry(country);

  const flag = getFlagEmoji(country);
  const prefix = [flag, phonePrefix].filter(Boolean).join(' ');

  return shouldShowPrefix({
    phone,
    countryPhonePrefix: phonePrefix,
  })
    ? prefix
    : undefined;
}
